const Divider = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      return {
        // borderColor: theme.palette.base[60],
        borderColor: theme.palette.custom.stroke,
      };
    },
  },
};

export default Divider;
